<template>
    <div v-if="isAlertActive && getAlertByType(alertType) && getAlertByType(alertType)['extra']['message']">
        <div class="alert text-center rounded-0" :class="'alert-' + alertColor">{{ getAlertByType(alertType)['extra']['message'] }}</div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: 'Alerts',
        props: {
            alertType: {
                type: String,
                default: null
            },
            alertColor: {
                type: String,
                default: 'info'
            }
        },
        computed: {
            ...mapGetters({
                isAlertActive: 'settings/isAlertActive'
            })
        }
    }
</script>